<script setup lang="ts">
import { CurrencyDisplay, formatting, Models, useLocalization, useOrderViewContext } from '@hantera/portal-app';
import { Expandable, IconWarning } from '@hantera/design-system';
import StaticDiscount from "@/components/Order/Discounts/StaticDiscount.vue";
import NewDiscount from "@/components/Order/Discounts/NewDiscount.vue";

const { state } = useOrderViewContext();
const t = useLocalization('components.order.discounts');

</script>

<template>
  <div>
  
    <div class="box-content-label">
      {{ t('orderDiscounts') }}
    </div>
    <div class="box-content box-pop p list-separators">
      <Expandable
        v-for="discount in state.orderDiscounts"
        :key="discount.discountId"
        class="discount"
      >
        <template v-slot:label>
          <span>{{ discount.description }}</span>
          <span>{{ formatting.currency(-discount.calculatedTotal, state.currencyCode, CurrencyDisplay.none) }}</span>
        </template>
        
        <StaticDiscount
          :discount="discount"
        />
      </Expandable>
  
      <Expandable
        class="discount"
      >
        <template v-slot:label>
          {{ t('addNew') }}
        </template>
        <NewDiscount
          type="order"
        />
      </Expandable>
      
    </div>
  </div>
  
</template>

<style scoped>
.discount :deep(.expandable__label-value) {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right: 10px;
}

.discount-error {
  width: 16px;
  height: 16px;
  display: block;
  color: var(--color-error)
}
</style>